export enum AppointmentStatuses {
  "aguardando" = "aguardando",
  "agendado" = "agendado",
  "concluido" = "concluido",
  "cancelado" = "cancelado",
  "recusado" = "recusado",
  "em andamento" = "em andamento",
  "pendente" = "pendente",
}

export type AppointmentStatus = keyof typeof AppointmentStatuses;
